import type { IIap, IInApp } from '~/types/iap'

import { DEFAULT_IAP_PRICE_COUNTRY } from '~/const/template'
import { IAP_SUB_TYPE, IAP_STATUS, IAP_TYPE, IAP_PERIODICITY, IAP_FREE_TRIAL } from '~/types/iap'

export const iapMock: IIap[] = [
  {
    app_key: 'publishing_sample',
    app_store_id: '1421134105',
    device_type: 'ios',
    id: 'iapForeverAllLanguages',
    is_enable: true,
    prices: {
      [DEFAULT_IAP_PRICE_COUNTRY]: {
        country: 'US',
        currency: 'USD',
        currency_symbol: '$',
        grace_period: '',
        grace_period_days: 0,
        price: 44.99,
        price_formatted: '$44.99',
        price_micros: 44990000,
        price_net: 31.5,
        price_net_after_first_year: 0,
        price_net_after_first_year_formatted: '0.0',
        price_net_formatted: '$31.50',
        price_net_micros: 31500000,
        subscription_period: '',
        subscription_period_days: 0,
        trial_period: '',
        trial_period_days: 0,
      },
    },
    sku: 'appstore.com.djit.MWMPublishingSDKSampleApp.nonconsumable.07.49.99',
    status: IAP_STATUS.APPROVED,
    sub_type: IAP_SUB_TYPE.CONSUMABLE,
    title: 'nonconsumable.07.49.99',
    type: IAP_TYPE.PRODUCT,
    unlockables: {
      publishing_sample: {
        android: ['publishing_sample.features.premium'],
        ios: ['publishing_sample.features.premium'],
      },
    },
  },
]

export const mockInApp: IInApp = {
  app_key: 'edjing_mix',
  created_at: 1727079608501,
  default_price_usd: 79.99,
  device_type: 'ios',
  free_trial: IAP_FREE_TRIAL.THREE_DAYS,
  intro_offer_duration_in_days: 0,
  intro_offer_price_usd: 0,
  offers: [
    {
      available_in_dev: true,
      available_in_prod: true,
      features_groups: [],
      in_apps: [],
      name: 'mock_offer_name',
      offer_id: 'mock_offer_id',
    },
  ],
  original_status: 'APPROVED',
  periodicity: IAP_PERIODICITY.YEARLY,
  sku: 'appstore.com.mwm.edjing_mix.subscription.annually.03.79.99',
  status: 'ready',
  store_id: '6449492913',
  sub_type: 'auto_renew',
  type: IAP_TYPE.SUBSCRIPTION,
}
